import { render } from "./SelectList.vue?vue&type=template&id=452f6673&scoped=true"
import script from "./SelectList.vue?vue&type=script&lang=js"
export * from "./SelectList.vue?vue&type=script&lang=js"

import "./SelectList.vue?vue&type=style&index=0&id=452f6673&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452f6673"]])

export default __exports__